import React from "react";
import { Route } from "react-router-dom";
import SEO from "../seo";

const PublicRoute = (props) => {
  const { component: Component, path, ...rest } = props;
  const shouldRender = props.computedMatch.path === path;

  if (!shouldRender) return null;

  return (
    <React.Fragment>
      <SEO update={new Date} />
      <Route {...rest} component={Component} />
    </React.Fragment>
  );
};

export default PublicRoute;
